import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserService } from '../services';
import { CommonService } from '../services/common.service';

@Injectable({
  providedIn: 'root',
})
export class UserSlugResolver implements Resolve<boolean> {
  constructor(
    private _common: CommonService,
    private _user: UserService,
  ) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      let slug = route.params['slug'];
      let sport = route.params['sport'] || '';
      let id = slug?.split('-').pop();
      if (this._common.isBrowser) {
        id = atob(id);
      } else {
        id = Buffer.from(id, 'base64'); // Ta-da
      }
      this._user.userstate.next(null);
      let params = new HttpParams().set('sport', sport);
      let stats = await this._user.userStats(id, params);
      this._user.userstate.next(stats.data);
      this._common.setTitle(`${stats.data?.user?.name}’s Profile`);
      this._common.updateMeta(
        'description',
        `${stats.data?.user?.name}’s Profile on Kingpin.pro`
      );
      resolve(id);
    });
  }
}
